import { ReactNode } from 'react';

import { DiagramPanelLayout } from '@/components/layout/DiagramPanelLayout';

import { useFamilyTreeContext } from '../contexts/familyTree.context';

export interface FamilyTreeContextContainerProps {
  height: number;
  width: number;
  children: ReactNode;
}

export function FamilyTreeContextContainer({
  height,
  width,
  children,
}: FamilyTreeContextContainerProps) {
  const { state } = useFamilyTreeContext();
  const { isSidePanelOpen, presentationMode } = state;

  // In presentation mode the side panel renders as a portaled overlay (see
  // PresentationFamilyTreeEditDrawer), so don't reserve an inline column for it
  // here — that would shrink the chart behind the floating overlay.
  const reserveInlinePanel = isSidePanelOpen && !presentationMode;

  return (
    <DiagramPanelLayout
      isPanelOpen={reserveInlinePanel}
      gap={reserveInlinePanel ? 2 : 0}
      height={height}
      width={width}
    >
      {children}
    </DiagramPanelLayout>
  );
}
